import { render, staticRenderFns } from "./KidsNicheIcon.vue?vue&type=template&id=16a2a1dc&scoped=true"
import script from "./KidsNicheIcon.vue?vue&type=script&lang=js"
export * from "./KidsNicheIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a2a1dc",
  null
  
)

export default component.exports